import countriesList from "./countries";
import timePeriodList from "./time-period";


export default [...timePeriodList, ...countriesList];